import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{! RESPONSIBLE TEAM: team-frontend-tech }}",{ moduleName: "embercom/templates/react-route.hbs" })